module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/mv_photowedding_01@2x-2f1cae0e6003c8bc9a4b5efd557f3f1f.webp";